import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { lastValueFrom, Observable } from 'rxjs';

const API_URL = 'url';

@Injectable({
    providedIn: 'root'
})
export class FileDownloadUploadService {
    constructor(
        private http: HttpClient
    ) { }

    public upload(url, file: Blob): Observable<any> {
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post(url, formData);
    }
    public downloadFileStream(content: any, filename: string) {
        if (!filename && content?.headers) {
            const contentDisposition = content.headers.get('Content-Disposition');
            if (contentDisposition) {
                filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
                filename = decodeURI(filename);
            }
        }
        if (!filename) {
            filename = `${Date.now()}.pdf`;
        }
        let binaryData = [];
        binaryData.push(content);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(
            new Blob(binaryData, { type: 'blob' })
        );
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }
    public uploadFormGroup(url, form: FormGroup): Observable<any> {
        var formData = new FormData();
        Object.keys(form.controls).forEach(key => {
            const v = form.get(key).value
            formData.append(key, v);
        });
        return this.http.post(url, formData);
    }
    public async download(url: string, filename: string, showInBrowser = false, asBlob = false, extension = '') {
        const response = await lastValueFrom(this.http
            .get(`${url}`,
                { responseType: 'blob', observe: 'response' }
            ));
        filename = filename || `MEDDATA_FILE_${Date.now()}.zip`;
        if (!asBlob) {
            this.downloadFileFromAttach(response.body, filename, null, showInBrowser);
        }
        else {
            return this.asBlob(response.body, this.getMimeType(extension));
        }
    }
    public async downloadFile(url: string, params?: any, caption?: string) {
        const response = await lastValueFrom(this.http
            .get(`${url}`,
                { params, responseType: 'blob', observe: 'response' }
            ));
        let filename = caption;
        if (!filename) {
            const contentDisposition = response.headers.get('Content-Disposition');
            if (contentDisposition) {
                filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
                filename = decodeURI(filename);
            }
            else {
                filename = `MEDDATA_FILE_${Date.now()}.zip`;
            }
        }
        this.downloadFileFromAttach(response.body, filename, null);
    }
    private downloadFileFromAttach(content, filename, contentType, showInBrowser = false) {
        const file = new Blob([content], { type: contentType });
        this.saveBlobAs(file, filename, showInBrowser);
    }
    private asBlob(content, contentType) {
        const file = new Blob([content], { type: contentType });
        return file;
    }
    private saveBlobAs(blob, filename, showInBrowser = false) {
        const fileURL = URL.createObjectURL(blob);

        // download file
        if (!showInBrowser) {
            const a = document.createElement('a');
            a.href = fileURL;
            a.target = '_self';
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        else {
            // show in browser
            window.open(fileURL, '_blank');
        }

    }
    private getMimeType(ext) {
        switch (ext) {
            case '.docx':
                return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case '.pdf':
                return 'application/pdf';
            case '.jpeg':
            case '.jpg':
                return 'image/jpeg';
            case '.png':
                return 'image/png';
            default:
                return 'application/*';
        }
    }
}
